import { useTrackingCode } from "react-hubspot-tracking-code-hook";
import { useContext, useEffect } from "react";
import AuthenticationContext from "../components/Auth/AuthenticationContext";

const useHubspotTracking = () => {
	const { claims } = useContext(AuthenticationContext);
	const emailClaim = claims.find((claim) => claim.name === "email");
	const { setPathPageView, setIdentity } = useTrackingCode();

	useEffect(() => {
		if (emailClaim?.value) {
			setIdentity(emailClaim.value);
		}
	}, [emailClaim]);

	const trackPageView = (title: string, path: string) => {
		if (emailClaim?.value) {
			document.title = title;
			setPathPageView(path);
		}
	};

	return { trackPageView };
};
export default useHubspotTracking;
